var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.groups),function(group){return _c('el-option-group',{key:("cog-" + (group.key)),attrs:{"label":group.label}},[_vm._l((group.options),function(option){return [_vm._t("default",null,{"option":option})]})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }